import React, { Fragment, useEffect, useState } from "react";
import { env } from "../../env";
// import footerlogo from "./footerlogo.png";
// import fb from "./fb.png";
// import twitter from "./twitter.png";
// import youtube from "./youtube.png";
// import insta from "./insta.png";
// import link from "./link.png";
// import rss from "./rss.png";
// import blog from "./blog.png";
// import ellipse from "./ellipse.png";
// import mail from "./mail.png";
// import apta from "./apta.png";

const FooterContent = () => {
  const [swVersion, setSwVersion] = useState(env.REACT_APP_SW_VERSION);

  useEffect(() => {
    console.log("Version", swVersion);
    setSwVersion(env.REACT_APP_SW_VERSION);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <Fragment>
      <div className="row first_footer" role="contentinfo">
        <div className="col-md-12" align="left">
          <div
            style={{
              marginLeft: "5%",
              marginRight: "5%",
              marginTop: "30px",
              marginBottom: "1%",
            }}
          >
            {/* <img
              src={footerlogo}
              alt="Metro logo"
              className="first_footer_logo"
            /> */}
            <div className="first_footer_items">
              <div className="first_footer_items_box">
                <div>
                  <span>
                    Metropolitan Transit Authority of Harris County
                    <br />
                    1900 Main St.
                    <br />
                    Houston, Texas 77002
                    <br />
                    713-635-4000
                  </span>
                </div>
                {/* <a href="https://www.ridemetro.org/facebook" target="_blank">
                  <img
                    src={fb}
                    width="40"
                    height="40"
                    alt="Connect with Houston Metro on Facebook"
                  />
                </a>
                <a href="https://www.ridemetro.org/twitter" target="_blank">
                  <img
                    src={twitter}
                    width="40"
                    height="40"
                    alt="Connect with Houston Metro on Twitter"
                  />
                </a>
                <a href="https://www.ridemetro.org/youtube" target="_blank">
                  <img
                    src={youtube}
                    width="40"
                    height="40"
                    alt="Connect with Houston Metro on Youtube"
                  />
                </a>
                <a href="https://www.ridemetro.org/instagram" target="_blank">
                  <img
                    src={insta}
                    width="40"
                    height="40"
                    alt="Connect with Houston Metro on Instagram"
                  />
                </a>
                <a href="https://www.ridemetro.org/linkedin" target="_blank">
                  <img
                    src={link}
                    width="40"
                    height="40"
                    alt="Connect with Houston Metro on Linkedin"
                  />
                </a>
                <a
                  href="https://www.ridemetro.org/Pages/RSS.aspx"
                  target="_blank"
                >
                  <img
                    src={rss}
                    width="40"
                    height="40"
                    alt="Connect with Houston Metro on RSS"
                  />
                </a>
                <a href="https://metroblog.ridemetro.org/" target="_blank">
                  <img
                    src={blog}
                    width="40"
                    height="40"
                    alt="Connect with Houston Metro on Blog"
                  />
                </a>
                <a
                  href="https://www.ridemetro.org/Pages/Podcast.aspx"
                  target="_blank"
                >
                  <img
                    src={ellipse}
                    width="40"
                    height="40"
                    alt="Connect with Houston Metro on Podcast"
                  />
                </a>
                <a
                  href="https://public.govdelivery.com/accounts/TXMETRO/subscriber/new?category_id=TXMETRO_C18"
                  target="_blank"
                >
                  <img
                    src={mail}
                    width="40"
                    height="40"
                    alt="Connect with Houston Metro by Mail"
                  />
                </a> */}
              </div>

              {/* <div className="first_footer_items_box">
                <span>
                  Metropolitan Transit Authority of Harris County
                  <br />
                  1900 Main St.
                  <br />
                  Houston, Texas 77002
                  <br />
                  713-635-4000
                </span>
              </div> */}

              {/* <div className="first_footer_items_box">
                <img
                  src={apta}
                  style={{ height: "130px" }}
                  alt="APTA Health and Safety commitment program participating systems"
                />
              </div> */}

              {/* <div className="first_footer_items_box">
                <div id="Group_91">
                  <div id="Customer_Service">
                    <span>Customer Service</span>
                  </div>
                  <div id="ID713-635-4000">
                    <span>713-635-4000</span>
                  </div>
                  <div id="TTY_713-635-6993_Comments_Cont">
                    <span>
                      (TTY) 713-635-6993
                      <br />
                      Comments
                      <br />
                      Contact METRO
                      <br />
                      MPD Connect
                    </span>
                  </div>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
      <div className="row second_footer">
        <div className="col-md-12" align="left">
          <div
            style={{
              marginLeft: "5%",
              marginRight: "5%",
              marginTop: "1%",
              marginBottom: "1%",
            }}
          >
            <div className="second_footer_items">
              <div className="second_footer_items_box">
                <span lang="French">Seleccione Idioma</span>
                <span lang="Chinese (simplified)">| 选择语言</span>
                <span lang="Vietnamese">| Chọn Ngôn Ngữ</span>
                <span lang="Arabic ">| ختار اللغة</span>
                <span lang="Spanish">| Sélectionner une langue</span>

                <div
                  id="google_translate_element"
                  aria-label="Select language for translation"
                  role="region"
                  tabIndex="0"
                ></div>
                {/* <button className="second_footer_items_box__button">
                  Submit
                </button> */}
              </div>
              <div className="second_footer_items_box">
                <span>
                  <a
                    href="https://www.ridemetro.org/Pages/Privacy.aspx"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Privacy Policy
                  </a>
                </span>
                <span>
                  <a
                    href="https://www.ridemetro.org/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    RideMETRO.org
                  </a>
                </span>
                {/* <span>EEO Policy</span>
                <span>Contact Metro</span>
                <span>Comments</span>
                <span>Webmaster</span>
                <span>
                  <br />
                  [Employee Login]
                </span> */}
              </div>
              <div className="second_footer_items_box">
                <span>
                  © 2022 Metropolitan Transit Authority of Harris County, Texas.
                  All Rights Reserved
                </span>
                {swVersion && (
                  <span>
                    <br />
                    Version: {swVersion}
                  </span>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default FooterContent;
